module.exports = __webpack_public_path__ + "static/media/guards.9c56edff.jpg";